export default {
  accountParametersView: {
    interviews: 'Interviews',
    configureInterviewLimits: 'Configure interview-related limits, expirations, and scheduling options.',
    candidate: 'Candidate',
    configureCandidateSettings: 'Configure candidate-related settings.',
    requisitions: 'Requisitions',
    configureRequisitionSettings: 'Configure requisition-related settings.',
    positionMining: 'Position Mining',
    configurePositionMiningSettings: 'Configure position mining settings.',
    offer: 'Offer',
    configureOfferSettings: 'Configure offer-related settings.',
    integrations: 'Integrations',
    configureThirdPartyIntegrations: 'Configure third-party integrations.',
    analytics: 'Analytics',
    configureAnalyticsSettings: 'Configure analytics settings.',
    success: 'Success',
    accountParametersUpdatedSuccessfully: 'Account parameters updated successfully.',
    error: 'Error',
    failedToUpdateAccountParameters: 'Failed to update account parameters.',
    accountParameters: 'Account Settings',
    manageAndConfigureAccountLevelSystemParameters: 'Manage and configure account-level system parameters.',
    reset: 'Reset',
    saveChanges: 'Save Changes',
    unsavedChanges: 'Unsaved Changes',
    youHaveUnsavedChangesAreYouSureYouWantToLeave: 'You have unsaved changes. Are you sure you want to leave?',
    cancel: 'Cancel',
    leave: 'Leave',
    appyhereParameters: 'AppyHere Settings',
    positionOverWrittenWarning: 'This account-level setting can be overridden at the position level.',
    todoList: 'To-Do List',
    todoListDescription: 'Configure To-Do List settings.',
  },
  analyticsPagesManager: {
    engName: 'EN Name',
    engURL: 'EN URL',
    frName: 'FR Name',
    frURL: 'FR URL',
    actions: 'Actions',
    edit: 'Edit',
    remove: 'Remove',
    analyticsPages: 'Analytics Pages',
    addPage: 'Add Page',
    editAnalyticsPage: 'Edit Analytics Page',
    addNewAnalyticsPage: 'Add New Analytics Page',
    save: 'Save',
    cancel: 'Cancel',
  },
  analyticsPane: {
    noChangesToSave: 'No changes to save',
    analytics: 'Analytics',
    analyticsDescription: 'Enable the Analytics View in Recruiter Web.',
    todoList: 'To-Do List',
    todoListDescription: 'Enable the To-Do List in Recruiter Web.',
    managementOverview: 'Management Overview',
    managementOverviewDescription: 'Enable the Management Overview in Recruiter Web.',
  },
  candidatePane: {
    filterCandidateByDays: 'Candidate Activity Filter',
    filterCandidateByDaysDescription:
      'This parameter controls filtering out candidates after a configurable number of days of inactivity.',
    days: 'days',
    resumeEnabled: 'Resume',
    resumeEnabledDescription:
      'When enabled, allows positions to request an optional resume as part of the prequalification process.',
    virtualRecruiterEnabled: 'Virtual Recruiter',
    virtualRecruiterEnabledDescription: 'When enabled, allows positions to use Virtual Recruiter.',
    languageEvaluationEnabled: 'Language Evaluation',
    languageEvaluationEnabledDescription: 'When enabled, allows positions to use Language Evaluations as selection criteria.',
    languageEvaluationValidityInDays: 'Language Evaluation Validity',
    languageEvaluationValidityInDaysDescription: 'How long Language Evaluation results are considered valid in days.',
    maxImageLimit: 'Max Image Limit',
    maxImageLimitDescription: 'The maximum number of images a candidate can upload for any HR Form question.',
    count: 'count',
    webApplyEnabled: 'Web Apply',
    webApplyEnabledDescription: 'Allow candidates to apply via a web-based alternative to the mobile app.',
    automaticLanguageEvaluationEnabled: 'Automated Language Evaluations',
    automaticLanguageEvaluationEnabledDescription:
      'When enabled, Language Evaluation ratings will be automatically performed by the system per your thresholds for the position. If a candidate fails, you will be required to evaluate them manually.',
    candidateReapplicationPeriodInDays: 'Candidate Reapplication Period',
    candidateReapplicationPeriodInDaysDescription: 'Days before a dismissed candidate can reapply to a position.',
    seekerInFlightDurationInHours: 'In-Flight Duration',
    seekerInFlightDurationInHoursDescription: 'Number of hours a candidate is considered "in-flight" by the system in hours.',
    hours: 'hours',
    scheduleMatchEnabled: 'Schedule Match',
    scheduleMatchEnabledDescription: 'When enabled, allows positions to use candidate availability as a preselection criteria.',
    seekerMaxHoursMatchingEnabled: 'Max Hours Matching',
    seekerMaxHoursMatchingEnabledDescription:
      "When enabled, Schedule Match will fail candidates who've indicated they cannot work enough hours for the position requirements.",
    shouldEnableAppliedPositions: 'Applied Positions',
    shouldEnableAppliedPositionsDescription: 'Shows the other positions the candidate has applied to within the account.',
  },
  dialogFlowAgentsManager: {
    displayName: 'Display Name',
    agentId: 'Agent ID',
    language: 'Language',
    location: 'Location',
    timezone: 'Time Zone',
    dialogflowAgents: 'Conversational AI Agents',
    addAgent: 'Add Agent',
    editDialogflowAgent: 'Edit Conversational AI Agent',
    addNewDialogflowAgent: 'Add New Conversational AI Agent',
    defaultLanguageCode: 'Default Language Code',
    timeZone: 'Time Zone',
    saveChanges: 'Save Changes',
    save: 'Save',
    cancel: 'Cancel',
    sortedDescending: 'sorted descending',
    sortedAscending: 'sorted ascending',
    unsorted: 'unsorted',
  },
  fitbandConfiguration: {
    fitbandConfiguration: 'Schedule Match Thresholds',
    done: 'Done',
    edit: 'Edit',
    mediumFit: 'Medium Fit',
    goodFit: 'Good Fit',
    poorFit: 'Poor Fit',
  },
  genericSettingsPane: {
    parameter: 'Parameter',
    description: 'Description',
    value: 'Value',
    reset: 'Reset',
    save: 'Save',
    noChangesToSave: 'No changes to save',
    valueBelowRecommendedMinimum: 'Value is below the recommended minimum ({{min}}). This may cause unexpected system behaviour.',
    valueAboveRecommendedMaximum: 'Value is above the recommended maximum ({{max}}). This may impact system performance.',
    invalidUrl: 'Invalid URL',
    invalidEmailAddress: 'Invalid email address',
    fieldIsRequired: 'This field cannot be empty.',
    pleaseFixValidationErrorsBeforeSaving: 'You must correct validation errors before saving.',
  },
  integrationsPane: {
    competencyEvaluationPassThreshold: 'Competency Evaluation Pass Threshold',
    competencyEvaluationPassThresholdDescription: 'The minimum score required to pass the evaluation.',
    score: 'score',
    competencyEvaluationSubDomain: 'Competency Evaluation Sub Domain',
    competencyEvaluationSubDomainDescription: 'The URL subdomain provided by the partner for Competency Evaluation integration.',
    competencyEvaluationTemplateIdList: 'Competency Evaluation Template Identifiers',
    competencyEvaluationTemplateIdListDescription:
      'Comma-separated template identifiers. These can then be set at the position level.',
    hireFormPdfEmail: 'HR Form PDF Email Recipient',
    hireFormPdfEmailDescription: 'HR Form PDFs will be sent to this email when approved.',
    reset: 'Reset',
    save: 'Save',
    noChangesToSave: 'No changes to save',
    competencyEvaluation: 'Competency Evaluation',
    competencyEvaluationDescription: 'When enabled, allows positions to use the Competency Evaluation as preselection criteria.',
    dialogFlowEnabled: 'Conversational AI',
    dialogFlowEnabledDescription: 'When enabled, allows positions to use Conversational AI.',
    fitbandTemplateEnabled: 'Schedule Match Templates',
    fitbandTemplateEnabledDescription: 'When enabled, allows positions to use Schedule Match templates.',
    languageEvaluationTemplateEnabled: 'Language Evaluation Templates',
    languageEvaluationTemplateEnabledDescription: 'When enabled, allows positions to use Language Evaluation Templates.',
  },
  interviewsPane: {
    calendarEnabled: 'Calendar',
    calendarEnabledDescription: 'Allows recruiters to access the Calendar View.',
    freeOnHoldInterviews: 'Cancel Other Interviews For Candidates With Offer',
    freeOnHoldInterviewsDescription:
      'When enabled, candidates will have all their other interviews and offers cancelled upon accepting an offer.',
    interviewRequestExpiryDays: 'Interview Request Expiry',
    interviewRequestExpiryDaysDescription:
      "Automatically revoke outstanding interview requests once they've passed this threshold in days.",
    appointmentHoldThresholdInDays: 'Interview Hold Threshold',
    appointmentHoldThresholdInDaysDescription:
      'Once a candidate accepts an interview, they cannot receive other interview requests for the number of days configured.',
    maxLimitInterviews: 'Maximum Concurrent Interviews Per Position',
    maxLimitInterviewsDescription:
      'This controls how many booked interviews a single position can have at a given time. Once the limit is reached, no additional interview requests for that position will be sent until the concurrent interviews falls below the threshold.',
    adhocInterviewEnabled: 'On-Demand Interviews',
    adhocInterviewEnabledDescription: 'Allows users to send interview requests for specific times.',
    isShiftIntersectable: 'Intersectable Shifts',
    isShiftIntersectableDescription: 'Allows for multiple shifts within a single day.',
    count: 'count',
  },
  offerPane: {
    startDateWindow: 'First Day Of Availability Range',
    startDateWindowDescription:
      'When candidates accept an offer, this parameter regulates how far into the future they can set their first day of availability.',
    offerAcceptancePeriod: 'Offer Acceptance Period',
    offerAcceptancePeriodDescription: 'Any offers pending for longer than this period will be automatically revoked.',
    candidateReofferEnabled: 'Candidate Re-Offer',
    candidateReofferEnabledDescription: 'Allows candidates to receive new offers when they have already received one.',
    offerConditionsEnabled: 'Offer Conditions',
    offerConditionsEnabledDescription:
      'Allows additional conditions to be added to job offers, both in the position and at offer time. These conditions must be accepted by the candidate to continue.',
    days: 'days',
  },
  positionMiningPane: {
    positionMiningEnabled: 'Position Mining',
    positionMiningEnabledDescription:
      'When enabled, the system will look for more optimal fits for a candidate in other close locations with open positions.',
    positionMiningRadius: 'Position Mining Radius',
    positionMiningRadiusDescription: 'Determines how far the system will look for eligible positions.',
    group: 'Group',
    inputRadius: 'Radius',
    enablePositionMiningToSet: 'Enable Position Mining to set radius',
    km: 'KM',
    miles: 'Miles',
  },
  requisitionPane: {
    requisitionWebhookURL: 'Requisition Webhook URL',
    requisitionWebhookURLDescription: 'Where AppyHere will send requisition status updates when they occur.',
    requisitionActiveThresholdDays: 'Requisition Recruitment Start Date',
    requisitionActiveThresholdDaysDescription:
      "The system will only begin to reach out to candidates if a requisition's effective date is closer to the current date than the number of days set for this parameter.",
    days: 'days',
    requisitionWebhookRetryCount: 'Requisition Webhook Retry Count',
    requisitionWebhookRetryCountDescription:
      'The number of times a status update will retry sending to the specified Webhook URL after an error.',
    retries: 'retries',
    hireFormEnabled: 'HR Form',
    hireFormEnabledDescription:
      'When enabled, positions will now have HR Forms as part of their onboarding process prior to hiring the candidate.',
    hireFormTemplateEnabled: 'HR Form Templates',
    hireFormTemplateEnabledDescription: 'Allows the creation of HR Form templates to be assigned to positions.',
    positionSalaryCeilingValidation: 'Allow Salary Ceiling Overrides',
    positionSalaryCeilingValidationDescription:
      "Permit requisitions to be saved even if the salary exceeds the position's maximum pay range",
    deactivateSalaryValidationModal: {
      title: 'Allow Salary Ceiling Override?',
      body:
        'By allowing this, you acknowledge full responsibility for ensuring salary offer remain compliant with company policy and local labor laws.',
      cancelBtn: 'Cancel',
      allowBtn: 'Allow',
    },
  },
  todoPane: {
    hireForm: {
      title: 'Hire Form',
      requested12HoursAgo: {
        title: 'Requested 12 Hours Ago',
        description: 'When enabled,Todo dashboard will show Hire Form request from 12 hours ago',
      },
      requested24HoursAgo: {
        title: 'Requested 24 Hours Ago',
        description: 'When enabled,Todo dashboard will show Hire Form request from 24 hours ago',
      },
      requested48HoursAgo: {
        title: 'Requested 48 Hours Ago',
        description: 'When enabled,Todo dashboard will show Hire Form request from 48 hours ago',
      },
      requested72HoursAgo: {
        title: 'Requested 72 Hours Ago',
        description: 'When enabled,Todo dashboard will show Hire Form request from 72 hours ago',
      },
      resubmission12HoursAgo: {
        title: 'Resubmission 12 Hours Ago',
        description: 'When enabled,Todo dashboard will show Hire Form request from 12 hours ago',
      },
      resubmission24HoursAgo: {
        title: 'Resubmission 24 Hours Ago',
        description: 'When enabled,Todo dashboard will show Hire Form request from 24 hours ago',
      },
      resubmission48HoursAgo: {
        title: 'Resubmission 48 Hours Ago',
        description: 'When enabled,Todo dashboard will show Hire From request from 48 hours ago',
      },
      resubmission72HoursAgo: {
        title: 'Resubmission 72 Hours Ago',
        description: 'When enabled,Todo dashboard will show Hire From request from 72 hours ago',
      },
    },
    offerMade: {
      title: 'Offer Made',
      twelveHoursAgo: {
        title: '12 Hours Ago',
        description: 'When enabled,Todo dashboard will show Offer Made from 12 hours ago',
      },
      twentyFourHoursAgo: {
        title: '24 Four Hours Ago',
        description: 'When enabled,Todo dashboard will show Offer Made from 24 hours ago',
      },
      thirtySixHoursAgo: {
        title: '36 Hours Ago',
        description: 'When enabled,Todo dashboard will show Offer Made from 36 hours ago',
      },
      fortyEightHoursAgo: {
        title: '48 Hours Ago',
        description: 'When enabled,Todo dashboard will show Offer Made from 48 hours ago',
      },
    },
    offerRejected: {
      title: 'Offer Rejected',
      twelveHoursAgo: {
        title: '12 Hours Ago',
        description: 'When enabled,Todo dashboard will show Offer Rejected from 12 hours ago',
      },
      twentyFourHoursAgo: {
        title: '24 Hours Ago',
        description: 'When enabled,Todo dashboard will show Offer Rejected from 24 hours ago',
      },
      thirtySixHoursAgo: {
        title: '36 Hours Ago',
        description: 'When enabled,Todo dashboard will show Offer Rejected from 36 hours ago',
      },
      fortyEightHoursAgo: {
        title: '48 Hours Ago',
        description: 'When enabled,Todo dashboard will show Offer Rejected from 48 hours ago',
      },
    },
    offerExpired: {
      title: 'Offer Expired',
      twelveHoursAgo: {
        title: '12 Hours Ago',
        description: 'When enabled,Todo dashboard will show Offer Expired from 12 hours ago',
      },
      twentyFourHoursAgo: {
        title: '24 Hours Ago',
        description: 'When enabled,Todo dashboard will show Offer Expired from 24 hours ago',
      },
      thirtySixHoursAgo: {
        title: '36 Hours Ago',
        description: 'When enabled,Todo dashboard will show Offer Expired from 36 hours ago',
      },
      fortyEightHoursAgo: {
        title: '48 Hours Ago',
        description: 'When enabled,Todo dashboard will show Offer Expired from 48 hours ago',
      },
    },
  },
};
